import { useState } from 'react'
import CustomMessage from './CustomMessage'
import CustomMessageModal from 'pages/Modals/CustomMessageModal'
import { Container } from './styles'

export default function CustomMessageList ({
  customMessages = [],
  onEdit: handleEdit = () => {},
  onDelete: handleDelete = () => {}
}) {
  const [customMessageData, setCustomMessageData] = useState (null)
  const [showCustomMessageModal, setShowCustomMessageModal] = useState (false)
  
  const editCustomMessage = customMessage => {
    setCustomMessageData (customMessage)
    toggleCustomMessageModal ()
  }

  const toggleCustomMessageModal = () => setShowCustomMessageModal (!showCustomMessageModal)

  if (customMessages.length === 0) return null

  return (
    <Container>
      {customMessages.map ((customMessage, index) => (
        <CustomMessage
          key={index}
          data={customMessage}
          onEdit={editCustomMessage}
          onDelete={handleDelete}
        />
      ))}
      {!!customMessageData && (
        <CustomMessageModal
          visible={showCustomMessageModal}
          data={customMessageData}
          onConfirm={handleEdit}
          onClose={toggleCustomMessageModal}
        />
      )}
    </Container>
  )
}
